const LEGACY_DRAFT_KEYS = [
  "jobs_store_v2_phase2",
  "proposal_new_search_draft_phase2",
] as const;

/**
 * Drafts saved by the removed manual job-offer/proposal form. They can still
 * sit in users' browsers, so they are cleared at logout (OQ1).
 */
export function clearLegacyJobOfferDrafts(storage: Storage = localStorage) {
  for (const key of LEGACY_DRAFT_KEYS) {
    storage.removeItem(key);
  }
}
